/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for SDCodeTableService.
 *
 */

import { ReduxUtils } from '@spm/core';

const GET_YES_NO_CODETABLE = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `SDCODETABLESERVICE/GET_YES_NO_CODETABLE`
);

const GET_CODETABLES_BY_TABLE_NAME = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `SDCODETABLESERVICE/GET_CODETABLES_BY_TABLE_NAME`
);

const GET_NOTIFICATION_TYPE_CODETABLE = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `SDCODETABLESERVICE/GET_NOTIFICATION_TYPE_CODETABLE`
);

const GET_GENDER_CODETABLE = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `SDCODETABLESERVICE/GET_GENDER_CODETABLE`
);

const GET_STATE_CODETABLE = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `SDCODETABLESERVICE/GET_STATE_CODETABLE`
);

export {
  GET_YES_NO_CODETABLE,
  GET_CODETABLES_BY_TABLE_NAME,
  GET_NOTIFICATION_TYPE_CODETABLE,
  GET_GENDER_CODETABLE,
  GET_STATE_CODETABLE,
};
